import {Field, Formik, FormikHelpers as FormikActions} from 'formik';
import React from 'react';
import {Button} from '~/components/Button';
import {Form, FormColumn, FormControls, FormRow, FormTitle, IntentText, TagsField} from '~/components/Form';
import {IModalComponent, IModalComponentClose} from '~/components/Modal';
import {Intent} from '~/lib/intent';

interface ISourcesFormValues {
    addTags: string[];
    removeTags: string[];
}

interface ISourcesForm {
    records?: string;
    onSubmit?: (tags: ISourcesFormValues, formikActions: FormikActions<ISourcesFormValues>, close?: IModalComponentClose) => void;
}

export const SourcesForm: IModalComponent<ISourcesForm> = (props) => <Formik initialValues={{addTags: [] as string[], removeTags: [] as string[]}}
    onSubmit={(tags, actions) => props.onSubmit?.(tags, actions, props.close)}
>
    {formik => <Form>
        <FormTitle>Edit Sources</FormTitle>
        {formik.status && <IntentText intent={Intent.DANGER}>{formik.status}</IntentText>}
        {props.records && <div>{props.records}</div>}
        <FormRow noBorder>
            <FormColumn>
                <Field name='addTags'
                    label='Add Tags'
                    options={{
                        placeholder: 'Tags',
                        disabled: formik.isSubmitting,
                        dropdown: true
                    }}
                    component={TagsField}
                />
                <Field name='removeTags'
                    label='Remove Tags'
                    options={{
                        placeholder: 'Tags',
                        disabled: formik.isSubmitting,
                        dropdown: true
                    }}
                    component={TagsField}
                />
            </FormColumn>
        </FormRow>
        <FormControls>
            <Button disabled={formik.isSubmitting}
                onClick={props.close}
            >Cancel</Button>
            <Button type='submit'
                disabled={formik.isSubmitting}
                intent={Intent.DANGER}
                rightIcon={formik.isSubmitting && <i className='fa fa-spinner fa-spin'/>}
            >Apply</Button>
        </FormControls>
    </Form>}
</Formik>;
